<template>
  <div>
    
    <div v-if="!rows.length">
      <div class="webkit-animation webkit-100-440"></div>
    </div>

      <swiper
          ref="mySwiper"
          :options="swiperOptions"
          :slides-per-view="1"
          :pagination="{ clickable: true }"
          :scrollbar="{ draggable: true }"
          class="swiper-container"
        >
          <swiper-slide v-for="(row, index) in rows" :key="index"
            :style="'background-image: url('+row.file+');background-size: cover'"
            :data-swiper-autoplay="row.duration + '000'">
            <div class="container">
              <div class="slider-widget">
                  <div class="bg-title text-uppercase white-color mb-2"
                    v-html="row.title"
                    :style="'color:'+row.title_color+' !important;white-space:break-spaces'">
                  </div>
                  <span class="bg-title-line "
                    :style="'background:'+row.lineColor+' !important'"></span>
                  <div class="text white-color mb-3"
                    v-html="row.content"
                    :style="'color:'+row.content_color+' !important;white-space:break-spaces'">
                  </div>
                  <router-link v-if="row.button" :to="row.redirect" class="btn-line white-color">
                    {{ row.button }} <span class="line white-background"></span>
                  </router-link>
              </div>
            </div>
          </swiper-slide>
      </swiper>

      <div class="swiper-arrows-content">
        <button class="swiperBtnPrev" slot="button-prev" @click="prev()">
          <span class="icon-arrow-left icon"></span>
        </button>
        <button class="swiperBtnNext" slot="button-next" @click="next()">
          <span class="icon-arrow-right icon"></span>
        </button>
      </div>

  </div>
</template>


<script>
// Very Important npm install swiper@5.4.5 
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import axios from "axios";

export default {
  name: "Slider",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      pgLoading: true,
      rows: [],

      swiperOptions: {
        speed: 700,
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: '.swiper-pagination'
        },
      },

    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },

  created() {
    this.fetchSlider();
  },
  methods: {
    prev() {
			this.$refs.mySwiper.$swiper.slidePrev();
		},
		next() {
			this.$refs.mySwiper.$swiper.slideNext();
		},
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
        })
        .catch(() => {});
    },


  },
};
</script>
